import * as React from "react";
import CartHeader from "../component/User/Cart/CartHeader.jsx";
import OrderSummary1 from "../component/User/Cart//OrderSummary1.jsx";
import PromoCheckout from "../component/User/Cart/CartPromoCheckout.jsx";
import Header from "../component/layout/Header";
import Footer from "../component/layout/Footer";
import CartItems from "../component/User/Cart/CartCartItems.jsx";

export default function CartLayout() {
  React.useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);
  const [promoDiscount, setPromoDiscount] = React.useState(null);
  const handleDiscountApplied = (discountData) => {
    setPromoDiscount(discountData);
  };
  React.useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);

  return (
    <div className="flex overflow-hidden flex-col">
      <Header activeLink="my-cart"/>
      <CartHeader />
      <CartItems />
      <OrderSummary1/>
      <Footer />
    </div>
  );
}